export default "__VITE_PUBLIC_ASSET__ed9ae4c3__"